import LiveMap from "./LiveMap";

function App() {
  return <LiveMap />;
}

export default App;